import { SKIP_REASONS } from "@/lib/agents/messaging/skip-reasons"

/** Conversations per page, named here so the «Show more» button can say how many it loads. */
export const MISSED_REPLY_PAGE_SIZE = 10

/** What a Missed replies row opens into. */
export type MissedReplyDetail = "none" | "wordings" | "conversations" | "split_conversations"

export function missedReplyDetail(cause: string): MissedReplyDetail {
  switch (cause) {
    case SKIP_REASONS.NON_ACTIONABLE:
      return "none"
    case SKIP_REASONS.AI_SKIP_REPLY:
      return "wordings"
    case SKIP_REASONS.AI_PAUSED_OR_DISABLED:
      return "split_conversations"
    default:
      return "conversations"
  }
}

/** A conversation the agent stayed out of was answered later when any real outbound message followed the marker. */
export const PAUSED_SPLITS = ["nobody_answered", "answered_later"] as const
export type PausedSplit = (typeof PAUSED_SPLITS)[number]
